import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1d78362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-content-wrapper" }
const _hoisted_2 = { class: "price" }
const _hoisted_3 = {
  datetime: "{{ eventDate }}",
  class: "event-date"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Doors Open:", -1))
const _hoisted_7 = { class: "quantity-count" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = {
  key: 1,
  class: "add-to-cart"
}
const _hoisted_10 = {
  key: 2,
  class: "sold-out"
}
const _hoisted_11 = {
  key: 3,
  class: "loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerElement = _resolveComponent("SpinnerElement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "$" + _toDisplayString(Math.floor(_ctx.productPrice)), 1),
    _createElementVNode("time", _hoisted_3, _toDisplayString(_ctx.rawEventDate), 1),
    _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createTextVNode(" " + _toDisplayString(_ctx.time), 1)
    ]),
    _createElementVNode("div", _hoisted_7, "Qty: " + _toDisplayString(_ctx.totalQuantity), 1),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.totalQuantity > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quantity) = $event)),
            class: "quantity"
          }, null, 512), [
            [_vModelText, _ctx.quantity]
          ]),
          _createElementVNode("button", {
            class: "add-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addProductToCart && _ctx.addProductToCart(...args)))
          }, "Add to cart")
        ]))
      : _createCommentVNode("", true),
    (_ctx.totalQuantity === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Sold Out! "))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_SpinnerElement, { text: "Adding Product" })
        ]))
      : _createCommentVNode("", true)
  ]))
}